import React, { useState, useEffect } from "react";
import NavigationBar from "../NavBar";
import "../../CSS/Courses.css"
import { useLocation } from "react-router-dom";
import rightArrow from "../../Assets/Images/Tech/Icons/right-white-arrow-icon.svg"
import advisorImage from "../../Assets/Images/Tech/Course/9.png"
import advisorgif from "../../Assets/Images/Tech/Course/for school (1).gif"
import faqImg from "../../Assets/Images/Tech/AboutUs/faq-video.mp4"
import Footer from "../Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import foundation from "../../Assets/Images/Tech/AboutUs/englishandskill.mp4"
import imagepng from "../../Assets/Images/Tech/AboutUs/5.png"


import { Helmet } from "react-helmet";



const FoundationCourse = () => {

    const loc = useLocation()
    const handleLanguageSelect = (languageUrl) => {
        // Directly navigate to the provided URL
        window.location.href = languageUrl;
    };
    const [showArrow, setShowArrow] = useState(false);

    // Handle scroll events
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowArrow(true);
                console.log("scroll event");
            } else {
                setShowArrow(false);
                console.log("scroll event false");
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Scroll to the top of the page
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };



    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://static.elfsight.com/platform/platform.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div>
            <Helmet>
                <title>Foundation English Course Online | Anglofone</title>
                <meta name="description" content="Description: Build a strong foundation in English with Anglofone’s Foundation course. Learn grammar, vocabulary, and conversation." />
            </Helmet>
            <meta name="keywords" content="Foundation English course" />
            <NavigationBar navIndex="Courses" />

            <div>

                <section className="grow-banner">
                    <div id="carouselExampleIndicators" className="carousel slide pointer-event" data-bs-ride="carousel">
                        <div className="carousel-inner ">
                            <div className="carousel-item about-banner_english-skill active">
                                <div className="container">
                                    <div className="banner align-items-center">
                                        <div className="banner-in ">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    {/* <h1>Foundation Course</h1> */}
                                                    <nav aria-label="breadcrumb">
                                                        <ol className="breadcrumb">
                                                            <li className="breadcrumb-item">
                                                                {/* <a href="index.html">Home</a> */}
                                                            </li>
                                                            <li className="breadcrumb-item active" aria-current="page">
                                                                {/* <a href="index.html">Foundation Course</a> */}
                                                            </li>
                                                        </ol>
                                                    </nav>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="section-why-choose-us light-red-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="pe-3">
                                    <img src={advisorgif} className="img-fluid" />
                                </div>

                            </div>
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* <h6>Course Info</h6> */}
                                        <h2>Learn English
                                            <br></br>
                                            <span className="text-primary">Anywhere ... Anytime...</span>
                                        </h2>
                                        <div className="bullet-arrow">
                                            <ul>

                                                <li>Fun, hands-on learning: Games, roleplay, group work, and real-life practice.</li>
                                                <li>Flexible classes: We can come to your school or company, teach online, or do both</li>
                                                <li>Custom classes: We will design lessons to fit your school, college, or office needs.</li>
                                                <li>Expert Trainers with years of experience will lead the sessions</li>

                                            </ul>

                                        </div>
                                        <button
                                            className="btn btn-danger btn-theme join-now-button"
                                            type="button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#customModalinHome"
                                        >
                                            Join Now
                                            <img src={rightArrow} alt="grow" className="join-now-arrow" />
                                        </button>


                                        {/* Custom Modal */}
                                        <div
                                            className="modal fade"
                                            id="customModalinHome"
                                            tabIndex="-1"
                                            aria-hidden="true"
                                        >
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content custom-modal-content">
                                                    <div className="modal-header custom-modal-header">
                                                        <h5 className="modal-title">Select Language</h5>
                                                        <i
                                                            className="custom-close-btn"
                                                            data-bs-dismiss="modal"
                                                            aria-label="Close"
                                                        >
                                                            &times;
                                                        </i>


                                                    </div>
                                                    <div className="modal-body custom-modal-body">
                                                        <ul className="language-list">
                                                            <li
                                                                onClick={() =>
                                                                    handleLanguageSelect("https://wa.link/66k1to")
                                                                }
                                                                className="language-item" style={{ listStyle: "none" }}
                                                            >
                                                                Malayalam
                                                            </li>
                                                            <li
                                                                onClick={() =>
                                                                    handleLanguageSelect("https://wa.link/0nfcxo")
                                                                }
                                                                className="language-item"
                                                            >
                                                                Tamil
                                                            </li>
                                                            <li
                                                                onClick={() =>
                                                                    handleLanguageSelect("https://wa.link/pm49ct")
                                                                }
                                                                className="language-item"
                                                            >
                                                                Telugu
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {showArrow && (
                    <button
                        className="back-to-top"
                        onClick={scrollToTop}
                        aria-label="Back to top"
                    >
                        ↑
                    </button>
                )}
                <section className="section-why-choose-us pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h2>Who Can
                                            <br></br>
                                            <span className="text-primary fw-light">Choose this Course?</span>
                                        </h2>
                                        <section className="swiper-section">
                                            {/* <Swiper
                                                effect={'coverflow'}
                                                grabCursor={true}
                                                centeredSlides={true}
                                                slidesPerView={'auto'}
                                                coverflowEffect={{
                                                    rotate: 0,
                                                    stretch: 0,
                                                    depth: 150,
                                                    modifier: 3,
                                                    slideShadows: true,
                                                }}
                                                loop={true}
                                                // pagination={{ clickable: true }}
                                                modules={[EffectCoverflow, Pagination]}
                                                className="mySwiper"
                                            >
                                               <SwiperSlide>
                                                    <div className = "testimonialBox">
                                                    <div className="details">
                                                                <div className="imgBx">
                                                                <img src="https://swiperjs.com/demos/images/nature-1.jpg" />
                                                                </div>
                                                            
                                                            </div>
                                                        <div className ="content">
                                                            <p>Anyone who wants to learn basic grammar and daily life words.
                                                            </p>
                                                           
                                                        </div>
                                                    </div>
                                                   
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className = "testimonialBox">
                                                    <div className="details">
                                                                <div className="imgBx">
                                                                <img src="https://swiperjs.com/demos/images/nature-1.jpg" />
                                                                </div>
                                                           
                                                            </div>
                                                        <div className ="content">
                                                            <p>Anyone looking to learn new words for daily life conversations.
                                                            </p>
                                                           
                                                        </div>
                                                    </div>
                                                   
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className = "testimonialBox">
                                                    <div className="details">
                                                                <div className="imgBx">
                                                                <img src="https://swiperjs.com/demos/images/nature-1.jpg" />
                                                                </div>
                                                                
                                                            </div>
                                                        <div className ="content">
                                                            <p>Anyone who needs personal attention.
                                                            </p>
                                                           
                                                        </div>
                                                    </div>
                                                   
                                                </SwiperSlide>
                                            </Swiper> */}
                                            <video src={foundation} className="img-fluid d-block mx-auto" autoPlay loop muted playsInline>

                                            </video>

                                        </section>


                                    </div>
                                </div>

                            </div>
                            <div className="col-md-3">
                                <div className="pe-3">
                                    <img src={imagepng} className="img-fluid-adv" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* faq */}
                <section className="section-faq">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5">
                                <video src={faqImg} className="img-fluid d-block mx-auto" autoPlay loop muted playsInline>
                                </video>
                            </div>
                            <div className="col-md-7">
                                <div className="row">
                                    {/* <div className="col-md-10">
                                        <div className="spacing"></div>
                                    </div> */}
                                    <div className="col-md-12">
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        Who can join this program?
                                                    </button>
                                                </h4>
                                                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#ccordionExample">
                                                    <div className="accordion-body">
                                                        Anyone! Young children, older students, teachers, staff, job seekers, and professionals.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingTwo">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                        Is the program only for schools or colleges?
                                                    </button>
                                                </h4>
                                                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        No! It is for schools, colleges, universities, and companies. We customize the lessons for each group to fit what they need.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingThree">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        Do you offer phonics for primary children?
                                                    </button>
                                                </h4>
                                                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! We teach phonics and reading for little kids, so they can learn English sounds and letters easily.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingFour">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                        Can you make the program fit our needs?
                                                    </button>
                                                </h4>
                                                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! We always ask you what your team or students need, and we make the lessons just for you.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingFive">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                        Are lessons different for primary, high school, college, and working adults?
                                                    </button>
                                                </h4>
                                                <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! We make lessons suitable for young children, older students, and professionals. Everyone learns what helps them most.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingSix">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                                        How do you decide what to teach?
                                                    </button>
                                                </h4>
                                                <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Expert teachers and trainers create lessons based on what works best for each age, job, or group, using brain-friendly methods.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingSeven">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                                        Is the training only about speaking?

                                                    </button>
                                                </h4>
                                                <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        No! We teach speaking, listening, reading, writing, teamwork, leadership, interview skills, and more.                                            </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingEight">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                                        Can you add special topics, like customer service or leadership?
                                                    </button>
                                                </h4>
                                                <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! If your group needs something special, like HR skills, sales, or presentations, we add it.  </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingNine">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                                        Is the program fun?
                                                    </button>
                                                </h4>
                                                <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! We play games, use group activities, and real-life practice to make every class enjoyable.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingTen">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                                                        Do you offer classes online and offline?
                                                    </button>
                                                </h4>
                                                <div id="collapseTen" className="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! We can teach in your school, college, or office, online through video, or a mix of both.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingEleven">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                                                        How long does the course take?
                                                    </button>
                                                </h4>
                                                <div id="collapseEleven" className="accordion-collapse collapse" aria-labelledby="headingEleven" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        It can be a short 2-day workshop or a longer program, whatever fits your time and calendar.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingTwelve">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
                                                        How do you know if someone is improving?
                                                    </button>
                                                </h4>
                                                <div id="collapseTwelve" className="accordion-collapse collapse" aria-labelledby="headingTwelve" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        We take small tests before and after, and give feedback and certificates when you finish.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingThirteen">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
                                                        Can this help with placements, promotions, or exams?
                                                    </button>
                                                </h4>
                                                <div id="collapseThirteen" className="accordion-collapse collapse" aria-labelledby="headingThirteen" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! Students do better in class or interviews and workers feel more confident at work.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingFourteen">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
                                                        Is the program certified?
                                                    </button>
                                                </h4>
                                                <div id="collapseFourteen" className="accordion-collapse collapse" aria-labelledby="headingFourteen" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! The program is ISO certified.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingFiveteen">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiveteen" aria-expanded="false" aria-controls="collapseFiveteen">
                                                        Will everyone get certificates?
                                                    </button>
                                                </h4>
                                                <div id="collapseFiveteen" className="accordion-collapse collapse" aria-labelledby="headingFiveteen" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Yes! After finishing, everyone gets a certificate. We can also add your school or company logo.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingSixteen">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixteen" aria-expanded="false" aria-controls="collapseSixteen">
                                                        Who teaches the classes?
                                                    </button>
                                                </h4>
                                                <div id="collapseSixteen" className="accordion-collapse collapse" aria-labelledby="headingSixteen" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Our trainers are industry experts. They know how to teach children, students, and adults by using the best methods.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingSeventeen">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventeen" aria-expanded="false" aria-controls="collapseSeventeen">
                                                        How big should a group be to join?
                                                    </button>
                                                </h4>
                                                <div id="collapseSeventeen" className="accordion-collapse collapse" aria-labelledby="headingSeventeen" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        We suggest at least 100 people for a batch, but you can talk to us about your group size.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingEighteen">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEighteen" aria-expanded="false" aria-controls="collapseEighteen">
                                                        How do you make the course easy for beginners?
                                                    </button>
                                                </h4>
                                                <div id="collapseEighteen" className="accordion-collapse collapse" aria-labelledby="headingEighteen" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        We use simple English, lots of examples, and start with the basics before moving forward.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h4 className="accordion-header" id="headingNinteen">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNineteen" aria-expanded="false" aria-controls="collapseNineteen">
                                                        How do we sign up or learn more?
                                                    </button>
                                                </h4>
                                                <div id="collapseNineteen" className="accordion-collapse collapse" aria-labelledby="headingNineteen" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Just contact us! We'll ask what you need and make a perfect plan for your school, college, or company.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-why-choose-us section-testimonial-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        {/* <h6>Testimonials</h6> */}
                                        <h2>What
                                            <span class="text-primary "> People&nbsp;Say</span>
                                        </h2>
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ border: 'none' }}>
                                    {/* Elfsight Google Reviews Widget */}
                                    <div
                                        className="elfsight-app-055282d1-f470-44fa-8a59-32cb680bd8ea"
                                        data-elfsight-app-lazy
                                        style={{ width: '100%', minHeight: '400px', marginTop: '30px' }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <footer>
                <Footer />
            </footer>
        </div>

    )
}

export default FoundationCourse;